import gql from 'graphql-tag';
import { clients } from '../../../util/clients';

const { backend, backendRest } = clients.direct;

export const urlEncodeObject = (obj) => new URLSearchParams(obj).toString();

export const TaxTransactionActions = {
  async generateNextTaxId({ commit, dispatch },
    { type, taxYear }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`query taxMaxTaxId ($criteria: taxStatsCriteriaType) {
          taxMaxTaxId (criteria: $criteria) { max, type }
        }`,
        variables: {
          criteria: { type, taxYear },
        },
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      const { taxMaxTaxId } = results.data;
      commit('setStats', taxMaxTaxId);
      if (taxMaxTaxId.max === 0) dispatch('flashError', 'There was a problem determining the last tax id.', { root: true });
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem determining the last tax id.', { root: true });
    }
  },
  // Create Omit / Create SA let the county type its own Tax ID, and the id they get
  // pre-filled comes from taxMaxTaxId, which every workstation polls at the same time.
  // Ask the server whether the pair is already on a record before letting the save go
  // through. Returns null when the check itself failed - callers must not block on that,
  // the upsert resolver refuses duplicates too.
  async checkTaxIdExists({ commit, dispatch }, { taxYear, taxId }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`query taxIdExists ($criteria: taxIdExistsCriteriaType) {
          taxIdExists (criteria: $criteria) { exists, taxYear, taxId }
        }`,
        variables: {
          criteria: { taxYear, taxId },
        },
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      return results.data.taxIdExists;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem checking whether the tax id is already in use.', { root: true });
    }
    return null;
  },
  async callToUpdateTaxGlobalVariable({ commit, dispatch }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`query updateGlobalTaxSystemConfig ($criteria: taxStatsCriteriaType) {
          updateGlobalTaxSystemConfig (criteria: $criteria) { max }
        }`,
        variables: {
          criteria: { },
        },
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem determining the tax global variable.', { root: true });
    }
  },
  async callMakeGLobalTaxIdUndefined({ commit, dispatch }, { type }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`query makeGLobalTaxIdUndefined ($criteria: taxStatsCriteriaType) {
          makeGLobalTaxIdUndefined (criteria: $criteria) { type }
        }`,
        variables: {
          criteria: { type },
        },
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem determining the tax global taxId variable.', { root: true });
    }
  },
  async sendMail({ dispatch, commit }, { item }) {
    let results;
    try {
      const url = `/taxInquiry/pick-list/emailStatement?${urlEncodeObject(item)}`;

      const response = await backendRest.get(url);
      if (response.status === 200) {
        dispatch('flashSuccess', `${response.data.message}`, { root: true });
      } else {
        dispatch('flashError', `${response.data.error}`, { root: true });
      }
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      // The endpoint now answers 502 with a reason when the send really failed, instead of
      // a 200 that claimed success before it had tried. Axios throws on that, so surface the
      // server's reason here rather than the copy-pasted refunds message that used to show.
      const msg = (e.response && e.response.data && e.response.data.error)
        || 'There was a problem sending the statement email.';
      dispatch('flashError', msg, { root: true });
    }
    return null;
  },
};

export default TaxTransactionActions;
